import React, { useContext } from 'react';
import { IoNotifications } from 'react-icons/io5';
import { Link } from 'react-router-dom';
import { AppContext } from '../../appContext';
import { CgProfile } from "react-icons/cg";
import { Badge, IconButton } from '@mui/material';
import { FaUserCircle } from 'react-icons/fa';
import ProfileDefault from '../../Assets/img/logos/place_profile.png';

function SearchHeader({ profileData, headerTxt }) {
  const { userDetails, chatCount } = useContext(AppContext);
  return (
    <div className="items-center py-6 px-6 bg-white hidden lg:flex xl:px-10 sticky top-0 z-[899] border-b border-gray-100 shadow-md">
      <div>
        <p className=" text-coalBlack headingText capitalize">
          {headerTxt}
        </p>
      </div>
      <div className="w-fit flex gap-4 items-center xl:gap-2 ms-auto">
        <Link to={'/notification'} className='relative'>
          <IconButton aria-label="notification">
            {
              chatCount > 0 && !isNaN(chatCount) ? (
                <Badge
                  badgeContent={chatCount}
                  slotProps={{ badge: { className: 'bg-accent text-white !font-bold' } }}
                >
                  <IoNotifications className='text-2xl text-inherit hover:bg-gray-50 rounded-full cursor-pointer' />
                </Badge>
              ) : (
                <IoNotifications className='text-2xl text-inherit hover:bg-gray-50 rounded-full cursor-pointer' />
              )
            }
          </IconButton>
        </Link>
          <Link to={'/profile/details'} className="flex items-center gap-1">
            {userDetails?.DoctorProfile?.coverPic ? (
              <img
                className="w-8 h-8 rounded-full object-cover"
                src={userDetails?.DoctorProfile?.coverPic ? `${process.env.REACT_APP_API_URL}/${userDetails?.DoctorProfile?.coverPic}` : ProfileDefault}
              />
            ) : (
              <IconButton>
                <FaUserCircle className='text-2xl text-inherit hover:bg-gray-50 rounded-full cursor-pointer' />
              </IconButton>
            )}
             <p className="baseText text-navLink capitalize">
             {userDetails?.DoctorProfile?.DoctorName}
            </p>
          </Link>
      </div>
    </div>
  );
}

export default SearchHeader;